module.exports = __webpack_public_path__ + "files/bf9e3bac7b11d4f1dc81845cd58cd5aa.png";